// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"move"},"children":[{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M7.75 3.25H8.75V4.25H7.75V3.25Z M15.25 3.25H16.25V4.25H15.25V3.25Z M15.25 8.75H16.25V9.75H15.25V8.75Z M15.25 14.25H16.25V15.25H15.25V14.25Z M15.25 19.75H16.25V20.75H15.25V19.75Z M7.75 8.75H8.75V9.75H7.75V8.75Z M7.75 14.25H8.75V15.25H7.75V14.25Z M7.75 19.75H8.75V20.75H7.75V19.75Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const MoveIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'move',
    ref,
    icon: element,
  },
));

MoveIcon.displayName = 'MoveIcon';

export default MoveIcon;
